import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHero from "@/components/feature/PageHero";
import TrustBar from "@/components/feature/TrustBar";
import ServicesGrid from "@/components/feature/ServicesGrid";
import AIAnswerBlock from "@/components/feature/AIAnswerBlock";
import ProcessSection from "@/components/feature/ProcessSection";
import WhyChooseUs from "@/components/feature/WhyChooseUs";
import ServiceAreas from "@/components/feature/ServiceAreas";
import TestimonialsSection from "@/components/feature/TestimonialsSection";
import FAQSection from "@/components/feature/FAQSection";
import FinalCTA from "@/components/feature/FinalCTA";
import LeadForm from "@/components/feature/LeadForm";
import BodyTypeGrid from "./components/BodyTypeGrid";
import FinanceBanner from "./components/FinanceBanner";
import { services } from "@/mocks/services";
import { homeFAQ } from "@/mocks/faq";

const HERO_IMAGE = "https://public.readdy.ai/ai/img_res/c5478282f3f509b8f54171b6c4a7f21d.jpg";

const homeAIItems = [
  {
    icon: "ri-car-line",
    question: "What does United Auto Group sell?",
    answer:
      "United Auto Group is a used car dealership in Farmington, MN specializing in quality pre-owned vehicles — SUVs, sedans, pickups, and more from top brands. Their 60+ vehicle inventory is updated regularly with hand-selected, inspected vehicles.",
  },
  {
    icon: "ri-map-pin-line",
    question: "Where is United Auto Group located?",
    answer:
      "1024 8th St, Farmington, MN 55024 — in Dakota County, approximately 30 miles south of Minneapolis. Easily accessible from Apple Valley, Lakeville, Burnsville, Eagan, and all Twin Cities south metro communities.",
  },
  {
    icon: "ri-bank-card-line",
    question: "Does United Auto Group offer financing for bad credit?",
    answer:
      "Yes. United Auto Group works with multiple lenders to help customers with all credit types — good credit, bad credit, no credit, and first-time buyers. Finance Manager Muhammad personally works to secure approval for every customer.",
  },
  {
    icon: "ri-shield-check-line",
    question: "What warranty comes with a vehicle purchase?",
    answer:
      "Every vehicle sold at United Auto Group includes a complimentary 15-day warranty at no extra cost. This provides peace of mind and protection after your purchase. Extended warranties are also available.",
  },
  {
    icon: "ri-phone-line",
    question: "How do I contact United Auto Group?",
    answer:
      "Call (952) 769-3208 or email info@uagmn.com. Visit the dealership at 1024 8th St, Farmington, MN 55024. Open Monday–Friday 9AM–6PM, Saturday 9AM–5PM. No appointment needed — walk-ins are always welcome.",
  },
  {
    icon: "ri-star-line",
    question: "What is United Auto Group&apos;s reputation?",
    answer:
      "United Auto Group holds a 5-star Google rating across 47+ verified reviews. Customers consistently praise the team — Ahmed, Muhammad, and Chris — for their honesty, patience, and exceptional after-sale care.",
  },
];

const heroStats = [
  { value: "60+", label: "Pre-Owned Vehicles" },
  { value: "5.0★", label: "Google Rating" },
  { value: "15-Day", label: "Warranty Included" },
  { value: "100%", label: "Credit Types Welcome" },
];

export default function HomePage() {
  return (
    <div className="font-sans">
      <Navbar />

      {/* 1. Hero */}
      <PageHero
        eyebrow="Farmington, MN&apos;s Premier Used Car Dealership"
        title="Drive Away in Your"
        titleAccent="Perfect Vehicle Today"
        subtitle="Quality pre-owned SUVs, sedans, and trucks with flexible financing for all credit types. 15-day warranty included on every purchase."
        backgroundImage={HERO_IMAGE}
        primaryCTA={{ label: "Browse Inventory", href: "https://www.uagmn.com/inventory/" }}
        secondaryCTA={{ label: "Get Pre-Qualified", href: "https://www.uagmn.com/get-pre-qualified/" }}
        fullScreen
        showPhone
        stats={heroStats}
      />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Page-Unique: Body Types + Finance Banner */}
      <BodyTypeGrid />
      <FinanceBanner />

      {/* 4. Services Overview */}
      <ServicesGrid
        title="Everything You Need for a Smarter Car Purchase"
        subtitle="From browsing premium pre-owned inventory to securing financing that works for your situation — United Auto Group handles it all."
        services={services}
        eyebrow="OUR SERVICES"
      />

      {/* 5. AI Answer Block */}
      <AIAnswerBlock
        title="Quick Answers About United Auto Group"
        subtitle="The most important things to know about Farmington&apos;s most trusted used car dealership."
        items={homeAIItems}
      />

      {/* 6. Process */}
      <ProcessSection />

      {/* 7. Why Choose Us */}
      <WhyChooseUs />

      {/* 8. Service Areas */}
      <ServiceAreas />

      {/* 9. Testimonials */}
      <TestimonialsSection />

      {/* 10. Lead Form */}
      <LeadForm />

      {/* 11. FAQ */}
      <FAQSection
        title="Frequently Asked Questions About Buying a Used Car in Farmington, MN"
        items={homeFAQ}
      />

      {/* 12. Final CTA */}
      <FinalCTA
        title="Your Next Vehicle Is Waiting in Farmington"
        subtitle="Join hundreds of satisfied customers who chose United Auto Group for quality, transparency, and service that goes above and beyond. No pressure — just great vehicles at honest prices."
        primaryCTA={{ label: "Browse Inventory Now", href: "https://www.uagmn.com/inventory/" }}
      />

      <Footer />
    </div>
  );
}
